import React from "react";
import { useFormContext } from "react-hook-form";
import * as changeCase from "change-case";

const FormErrors = () => {
    const { formState } = useFormContext();
    const errorList = formState.errors ? Object.values(formState.errors) : [];
    // Nested errors (e.g. an array of rows) carry no top-level message; their fields show them instead.
    const messages = errorList.flatMap((error) =>
        error && typeof error === "object" && "message" in error && error.message ? [error.message as string] : []
    );
    if (messages.length === 0) return null;
    return (
        <div className="p-2 border-2 border-red-500 rounded-md text-red-500" role="alert">
            {messages.map((message, i) => (
                <p key={i}>{changeCase.sentenceCase(message)}</p>
            ))}
        </div>
    );
};

export default FormErrors;
